export default "__VITE_ASSET__CH1A94pj__"